import React, { useState } from 'react';
import FormInput from './FormInput';
import NestedDueLevelsFields from './NestedDueLevelsFields';

const FundTypePicker = (props) => {
  const [fundType, setFundType] = useState(props.model.fund_type);

  return (
    <div className="space-y-6">
      {/* Fund Type Selection */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FormInput
          {...props}
          value={fundType}
          setValue={setFundType}
          description="Select how payments are structured"
        />
      </div>

      {/* Due Levels Section */}
      {fundType === 'dues' && (
        <NestedDueLevelsFields
          fund={props.model}
          errors={props.errors}
          dueLevels={props.due_levels}
          dueLevelStatuses={props.due_level_statuses}
          intervalOptions={props.interval_options}
          archiveUrlTemplate={props.archiveUrlTemplate}
          canArchive={props.canArchive}
        />
      )}
    </div>
  );
};

export default FundTypePicker;
